import { render, staticRenderFns } from "./floorRestaurant.vue?vue&type=template&id=68a767a0"
import script from "./floorRestaurant.vue?vue&type=script&lang=js"
export * from "./floorRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports